import React, { useState } from "react";
import sectionLogo from "../../../Assets/Image/new.PNG";
import "./Navigation.css";
import { Link, Outlet } from "react-router-dom";


export default function Navigation() {
  const [active, setActive] = useState("home");

  function toggleShow() {
    let navigation = document.querySelector(".navigation");
    let main = document.querySelector(".main");
    navigation.classList.toggle("active");
    main.classList.toggle("active");
  }
  return (
    <>
      <div className="navigation">
        <ul>
          <li>
            <img src={sectionLogo} alt="Logo" width={200} />
          </li>
          <li
            onClick={() => setActive("home")}
            className={active === "home" ? "hovered" : ""}
          >
            <Link to={``}>
              <span className="icon">
                <i class="fa-solid fa-house"></i>
              </span>
              <span className="title">Dashboard</span>
            </Link>
          </li>
          <li
            onClick={() => setActive("customers")}
            className={active === "customers" ? "hovered" : ""}
          >
            <Link to={`users`}>
              <span className="icon">
                <i class="fa-solid fa-users"></i>
              </span>
              <span className="title">Users</span>
            </Link>
          </li>
          <li
            onClick={() => setActive("cars")}
            className={active === "cars" ? "hovered" : ""}
          >
            <Link to={`cars`}>
              <span className="icon">
              <i class="fa-solid fa-car"></i>
              </span>
              <span className="title">Cars</span>
            </Link>
          </li>
          <li
            onClick={() => setActive("messages")}
            className={active === "messages" ? "hovered" : ""}
          >
            <Link to={`messages`}>
              <span className="icon">
              <i class="fa-solid fa-comment"></i>
              </span>
              <span className="title">Messages</span>
            </Link>
          </li>
          <li
            onClick={() => setActive("product")}
            className={active === "product" ? "hovered" : ""}
          >
            <Link to={`products`}>
              <span className="icon">
              <i class="fa-solid fa-bag-shopping"></i>
              </span>
              <span className="title">Products</span>
            </Link>
          </li>
          <li
            onClick={() => setActive("category")}
            className={active === "category" ? "hovered" : ""}
          >
            <Link to={`category`}>
              <span className="icon">
              <i class="fa-solid fa-table"></i>
              </span>
              <span className="title">Category</span>
            </Link>
          </li>
          <li
            onClick={() => setActive("package")}
            className={active === "package" ? "hovered" : ""}
          >
            <Link to={`package`}>
              <span className="icon">
              <i class="fa-solid fa-cubes"></i>
              </span>
              <span className="title">Package</span>
            </Link>
          </li>
          <li
            onClick={() => setActive("order")}
            className={active === "order" ? "hovered" : ""}
          >
            <Link to={`order`}>
              <span className="icon">
              <i class="fa-solid fa-money-bill"></i>
              </span>
              <span className="title">Order & Payment</span>
            </Link>
          </li>
        </ul>
      </div>

      <div className="main bg-body-secondary">
        <div className="topbar bg-second-color fixed-top">
          <div onClick={() => toggleShow()} className="toggle">
            <i className="fa-solid fa-bars"></i>
          </div>
          <div className="logo">
            <img src={sectionLogo} alt="Logo" width={200}/>
          </div>
        </div>
        <div className="container-outlet">
        <Outlet/>
        </div>

      </div>
    </>
  );
}
